
import { useAppSelector } from "@/hooks"
import { getIsLoading } from "@/store/appSlice"
import { useEffect } from "react"

const Loading = () => {
    const isLoading = useAppSelector(getIsLoading)

    useEffect(() => {
        const loadingElement = document.getElementById("loading");
        if (isLoading && loadingElement) {
            loadingElement.classList.add("show");
        } else if (!isLoading && loadingElement) {
            loadingElement.classList.remove("show");
        }
    }, [isLoading])

    return (<>
        <div id="loading">
          <div>データを取得している。。。</div>
          <div className="sk-three-bounce">
              <div className="sk-child sk-bounce1"></div>
              <div className="sk-child sk-bounce2"></div>
              <div className="sk-child sk-bounce3"></div>
          </div>
        </div>
    </>)
}

export default Loading